// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","metricsFormMainArea":"_3-1qKGPbzjHZsH17uxTBjD"};